import { Icon } from '@octano/global-ui';
import { ReactElement } from 'react';

import { CourseGroupListItem } from '../types';

interface ActionCellProps {
  row: CourseGroupListItem;
  onEdit: (id: number) => void;
  onDelete: (group: CourseGroupListItem) => void;
  editLabel: string;
  deleteLabel: string;
}

/**
 * HU 15564 — Task FE-B: celda de acciones del listado.
 * Editar navega a la vista de items (HU 15571) y eliminar dispara el flujo
 * de confirmación + delete del index.
 */
export default function ActionCell({
  row,
  onEdit,
  onDelete,
  editLabel,
  deleteLabel,
}: ActionCellProps): ReactElement {
  return (
    <div className="d-flex justify-content-center" style={{ gap: 8 }}>
      <button
        type="button"
        className="btn p-0"
        aria-label={editLabel}
        title={editLabel}
        onClick={() => onEdit(row.id)}
      >
        <Icon size="15" name="edit" color="primary" />
      </button>
      <button
        type="button"
        className="btn p-0"
        aria-label={deleteLabel}
        title={deleteLabel}
        onClick={() => onDelete(row)}
      >
        <Icon size="15" name="trash" color="primary" />
      </button>
    </div>
  );
}
